/** Site Details fields (matches API site-details schema). */
export const SITE_IN_A_BOX_SITE_DETAILS_KEYS = new Set([
    "entity",
    "customer_name",
    "site_name",
    "contact_name",
    "contact_email",
    "contact_number",
    "project_manager",
    "site_code",
    "address",
    "reference_id",
    "go_live_date",
    "number_of_sites",
]);
/** Connectivity / service-selection fields (matches API connectivity schema). */
export const SITE_IN_A_BOX_CONNECTIVITY_KEYS = new Set([
    "country",
    "site_type",
    "term_required",
    "needs_rapid_deployment",
    "needs_bonded_services",
    "static_ip_count",
    "is_temporary",
    "satellite_packages",
    "lte_packages",
    "standard_cpe",
    "advanced_cpe",
    "out_of_band_management_required",
    "managed_service_required",
    "communications_orbit_qty",
    "communications_galaxy_qty",
    "communications_cosmos_qty",
    "communications_skylink_qty",
    "communications_lte_swift_qty",
    "communications_lte_velocity_qty",
    "communications_lte_pulse_qty",
    "communications_lte_flight_qty",
    "communications_fibre_edge_qty",
    "communications_fibre_access_qty",
    "site_survey_required",
    "installation_lift_equipment_required",
    "project_management_required",
    "h_s_documentation_required",
    "has_h_s_requirements",
    "notes",
    "priority_shipping",
]);
export const pickSiteInABoxFormFields = (form, keys, extras = {}) => {
    const payload = { ...extras };
    for (const key of keys) {
        if (Object.prototype.hasOwnProperty.call(form, key)) {
            payload[key] = form[key];
        }
    }
    return payload;
};
export const buildSiteInABoxSiteDetailsPayload = (form, extras = {}) => pickSiteInABoxFormFields(form, SITE_IN_A_BOX_SITE_DETAILS_KEYS, extras);
export const buildSiteInABoxConnectivityPayload = (form, extras = {}) => pickSiteInABoxFormFields(form, SITE_IN_A_BOX_CONNECTIVITY_KEYS, extras);
